import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import React, { useState } from 'react';
import { Alert } from '../Alert';
import { ToastProps } from './interface';
import { useToastContext } from '@src/contexts/ToastContext/ToastContext';

export const Toast = ({ severity, message }: ToastProps) => {
  const [open, setOpen] = useState(true);
  const { setToast } = useToastContext();
  const handleClose = (_event: unknown, reason: SnackbarCloseReason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
    setToast?.(null);
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <div>
        <Alert
          severity={severity}
          variant="filled"
          title={message}
          showIcon={false}
          hideCloseIcon
          __library_only_minWidth={120}
          __library_only_maxWidth={600}
        />
      </div>
    </Snackbar>
  );
};
